'use client'
import { usePathname } from 'next/navigation'
import DropdownMenu from '../common/DropDownMenu'
import { Mxpdisplay } from '../common/PointsDisplay'
import { Ticket02Icon, DropletIcon, Folder01Icon, Exchange01Icon, MonadexLogo, Logo } from '@/utils/icons'
import { BlockNumberComponent } from '../common/blockNumber'
import { useBlockNumber } from '@/state/application/hooks'
import { useMediaQuery, useTheme, Box } from '@mui/material'
import Link from 'next/link'
import Image from 'next/image'
import Connect from '../common/ConnectButton'
import Faucet from '../common/Faucet'
import SearchBar from '../searchBar/searchBar'
const Header: React.FC<any> = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'))
  const blockNumber = useBlockNumber()

  const pathname = usePathname()
  const paths = [
    {
      id: 'swap-page',
      name: 'Swap',
      path: '/',
      logo: <Exchange01Icon className='text-white' width={15} />
    },
    {
      id: 'Pools-page',
      name: 'Pools',
      path: '/pools',
      logo: <DropletIcon width={15} />
    },
    {
      id: 'Raffle-page',
      name: 'Raffle',
      path: '/raffle',
      logo: <Ticket02Icon width={15} />
    },
    {
      id: 'Portfolio-page',
      name: 'Portfolio',
      path: '/portfolio',
      logo: <Folder01Icon width={15} />
    },
    // {
    //   id: 'Bridge',
    //   name: 'Bridge',
    //   path: '#',
    //   logo: ''
    // },
    {
      id: 'Points',
      name: 'Points',
      path: '/points',
      logo: ''
    }
  ]
  return (
    <Box className=' bg-primary/10'>
      <Box className='w-[95%] mx-auto flex justify-between py-2 items-center'>
        <div className='flex flex-col sm:flex-row items-center justify-between gap-8 '>
          <Box className='w-full sm:w-auto flex justify-center sm:justify-start gap-4'>
            <div>
              <Image src='https://imagedelivery.net/COrEjiX90UMaVnfrARSGdQ/07bef2e7-8645-403a-5245-6b7276f95000/public' alt='logo ' width={33} height={24} />
            </div>
            <div className='hidden md:block'>
              <Image src='https://imagedelivery.net/COrEjiX90UMaVnfrARSGdQ/f21158d8-aeb5-4b71-e0e1-31ba034bef00/public' alt='text_logo' width={186} height={40}/>
            </div>
          </Box>

          <Box className='hidden lg:block'>
            <nav className='flex flex-wrap justify-center sm:gap-6 ml-2'>
              {paths.map((k, v) => (
                <div key={v} className='flex items-center'>
                  {/* <p className='mr-2 text-lg text-white/60'>{k.logo}</p> */}
                  <Link
                    className={`
                  text-neutral-300 font-clash text-md md:text-md transition-all
                  hover:text-bgColor
                  ${pathname == k.path && 'text-primary'}
                  ${k.name === 'Points' ? 'text-primary italic drop-shadow-glow' : ''}
                `}
                    key={v}
                    href={k.path}
                  >
                    {k.name}
                  </Link>
                </div>
              ))}
            </nav>
          </Box>
        </div>
        <div>
          {/* <SearchBar /> */}
        </div>
        <Box className='flex items-center justify-center gap-4'>
          {!isTablet && <Mxpdisplay />}
          <Faucet />
          <Connect />
          <DropdownMenu />

        </Box>
      </Box>
    </Box>
  )
}
export default Header
